import { Routes } from '@angular/router';
import { Panelist } from './pages/panelist/panelist';
import { Cleanfeed } from './pages/cleanfeed/cleanfeed';
import { Ingest } from './pages/ingest/ingest';
import { Login } from './pages/login/login';
import { LoginGuard } from './core/guards/login.guard';
import { LogoutGuard } from './core/guards/logout.guard';
import { AuthGuard } from './core/guards/auth.guard';
import { MetricsPage } from './pages/metrics/metrics';
import { Audience } from './pages/audience/audience';

export const routes: Routes = [
  { path: '', redirectTo: 'audience', pathMatch: 'full' },
  { path: 'login', component: Login, canActivate: [LoginGuard], title: 'Medinbox AI Live - Login' },
  { path: 'logout', canActivate: [LogoutGuard], component: Login },
  {
    path: 'panelist',
    component: Panelist,
    canActivate: [AuthGuard],
    title: 'Medinbox AI Live - Panelist',
  },
  {
    path: 'ingest',
    component: Ingest,
    canActivate: [AuthGuard],
    title: 'Medinbox AI Live - Ingest',
  },
  {
    path: 'metrics',
    component: MetricsPage,
    canActivate: [AuthGuard],
    title: 'Medinbox AI Live - Metrics',
  },
  { path: 'cleanfeed', component: Cleanfeed, title: 'Medinbox AI Live - Cleanfeed' },
  { path: 'audience', component: Audience, title: 'Medinbox AI Live - Audience' },
  { path: '**', redirectTo: '/' },
];
